const SITE = "https://northcrestlandscaping.ca";
const DEFAULT_IMAGE = "https://images.unsplash.com/photo-1775733923991-e7223f9f44bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

/**
 * PageMeta — single source of truth for per-page SEO.
 *
 * Uses React 19 native metadata: <title>, <meta>, <link> rendered in component body
 * are automatically hoisted to <head>. react-helmet-async 2.x is broken on React 19
 * (only <title> updates, meta tags do not), so we use the native API instead.
 *
 * Props:
 *  - title:       page-specific title (will be appended with " | NorthCrest Landscaping" if not present)
 *  - description: 150–160 char description
 *  - path:        URL path beginning with "/" — used for canonical and og:url
 *  - image:       optional absolute OG image URL (defaults to brand image)
 *  - type:        og:type — "website" (default) or "article"
 */
export default function PageMeta({ title, description, path = "/", image, type = "website" }) {
  const fullTitle = title.includes("NorthCrest") ? title : `${title} | NorthCrest Landscaping`;
  const url = `${SITE}${path}`;
  const img = image || DEFAULT_IMAGE;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="NorthCrest Landscaping" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="en_CA" />
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
    </>
  );
}
